// import '../css/app.css';
import "./bootstrap";

import "../css/style.css";
import "../css/satoshi.css";
import "../css/simple-datatables.css";

import "jsvectormapcss";
import "flatpickrcss";
import "nouislidercss";
import "dropzonecss";

import { createInertiaApp } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createRoot, hydrateRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { configureZiggyFromPage } from "./ziggy";
import { trackMetaFlashEvent, trackMetaPageView } from "./utils/metaPixel";

const queryClient = new QueryClient();

const fireMetaPixelFlashEvent = (page) => {
    trackMetaFlashEvent(page?.props?.flash?.metaPixelEvent);
};

createInertiaApp({
    title: (title) => {
        const globalAppName = window.APP_NAME || "Laravel";
        return `${title} - ${globalAppName}`;
    },
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.jsx`,
            import.meta.glob("./Pages/**/*.jsx"),
        ),
    setup({ el, App, props }) {
        window.APP_NAME = props.initialPage.props.appName || "Laravel";
        configureZiggyFromPage(props.initialPage);

        const syncCsrfToken = (page) => {
            const token = page?.props?.csrf_token;
            if (!token) {
                return;
            }

            const meta = document.querySelector('meta[name="csrf-token"]');
            if (meta) {
                meta.setAttribute("content", token);
            }
        };

        syncCsrfToken(props.initialPage);
        fireMetaPixelFlashEvent(props.initialPage);

        document.addEventListener("inertia:success", (event) => {
            configureZiggyFromPage(event.detail.page);
            syncCsrfToken(event.detail.page);
            // Initial PageView is fired by the base pixel in app.blade.php;
            // subsequent Inertia navigations need an explicit PageView.
            trackMetaPageView();
            fireMetaPixelFlashEvent(event.detail.page);
        });

        const dsn = props.initialPage.props.sentryDsn;

        if (dsn) {
            Sentry.init({
                dsn: dsn,
                tracesSampleRate: 1.0,
                sendDefaultPii: true,
            });
        }

        const content = (
            <QueryClientProvider client={queryClient}>
                <App {...props} />
            </QueryClientProvider>
        );

        if (el.hasChildNodes()) {
            hydrateRoot(el, content);
        } else {
            createRoot(el).render(content);
        }
    },
    progress: {
        color: "#4B5563",
    },
});
